import { render } from "./FleetBundleResources.vue?vue&type=template&id=4db2ec70"
import script from "./FleetBundleResources.vue?vue&type=script&lang=js"
export * from "./FleetBundleResources.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__